import { render, staticRenderFns } from "./StandardTemplatePreview.vue?vue&type=template&id=0794af90&scoped=true&"
import script from "./StandardTemplatePreview.vue?vue&type=script&lang=js&"
export * from "./StandardTemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./StandardTemplatePreview.vue?vue&type=style&index=0&id=0794af90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794af90",
  null
  
)

export default component.exports